import { IndicacoesModel } from "model/api/gestao/indicacoes/indicacoes-model";
import { EnumStatusIndicacao } from "model/enums/enum-status-indicacao";
import { CardNaoEncontrado } from "views/components/cards";
import { CardIndicacoes } from "views/components/cards/card-indicacoes";
import { InformacaoIcon } from "views/components/icons";

export interface IndicacoesGridProps {
  list: Array<IndicacoesModel>;
  carregando: boolean;
  selectedList: Array<string>;
  onCardSelected: (id: string, status: EnumStatusIndicacao) => any;
  onCardChecked: (id: string) => any;
}

export const IndicacoesListData = (props: IndicacoesGridProps) => {

  const onCardSelected = (id: string, status: EnumStatusIndicacao) => {
    props.onCardSelected(id, status);
  };

  const onCardChecked = (id: string) => {
    props.onCardChecked(id);
  };

  return (
    <>
      {(props?.list ?? []).length === 0 && !props.carregando && (
        <CardNaoEncontrado
          mensagem="Nenhuma Indicação Encontrada."
          icon={<InformacaoIcon tipo="GERAL" />}
        />
      )}
      {(props?.list ?? []).length > 0 &&
        props.list.map((indicacao, index) => {
          return (
            <CardIndicacoes
              selected={
                props.selectedList.filter((item) => item === indicacao.id).length >
                  0
                  ? true
                  : false
              }
              onCheck={onCardChecked}
              onClick={onCardSelected}
              model={indicacao}
              key={index}
            />
          );
        })}
    </>
  );
}